// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"d5f143dc","314":"7d0ec0e1","325":"6125057d","526":"cfe60c86"}[chunkId] + ".chunk.js";
};